import { Box, Text } from "@mantine/core";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import DateFormat from "types/DateFormat";

type ChatDateDividerProps = {
  dateKey: string;
};

const ChatDateDivider = ({ dateKey }: ChatDateDividerProps) => {
  const { t } = useTranslation("discussions");

  const getDateDividerLabel = () => {
    const date = dayjs(dateKey, DateFormat.ONLY_DATE);

    if (date.isSame(dayjs(), "day")) {
      return t("today");
    }

    if (date.isSame(dayjs().subtract(1, "day"), "day")) {
      return t("yesterday");
    }

    return dateKey;
  };

  const label = getDateDividerLabel();

  return (
    <Box className="flex justify-center my-2">
      <Box className="bg-white text-gray-dark h-[16px] text-xs px-2 py-0 rounded-[5px]">
        <Text fw={400} fz="xs">
          {label}
        </Text>
      </Box>
    </Box>
  );
};

export default ChatDateDivider;
